import type { TabItem } from '@/components/custom/erp';
import type { FormDialogModel } from './hooks';
import { DetailTab } from './DetailTab';
import { TSCCTab } from './TSCCTab';
import { TaxTab } from './TaxTab';

export const FormTabs = (dialog: FormDialogModel): TabItem[] => {
  if (dialog.activeTab !== 'info') return [];

  const tabs: TabItem[] = [
    {
      id: 'details',
      label: 'Chi tiết',
      component: (
        <DetailTab
          formMode={dialog.formMode}
          rows={dialog.detail.rows}
          selectedRowUuid={dialog.detail.selectedRowUuid}
          selectedCell={dialog.detail.selectedCell}
          onRowClick={dialog.detail.handleRowClick}
          onCellClick={dialog.detail.handleCellClick}
          onAddRow={dialog.detail.handleAddRow}
          onDeleteRow={dialog.detail.handleDeleteRow}
          onCopyRow={dialog.detail.handleCopyRow}
          onPasteRow={dialog.detail.handlePasteRow}
          onMoveRow={dialog.detail.handleMoveRow}
          onCellValueChange={dialog.detail.handleCellValueChange}
          handleUpdateNonWritableFields={dialog.detail.setNonWritableFields}
          handleUpdatePasteConfigs={dialog.detail.setPasteConfigs}
          onRepeatForRows={dialog.detail.repeatRows}
          state={dialog.formState.state}
          constraints={dialog.constraints}
          isPasting={dialog.detail.isPasting}
        />
      )
    },
    {
      id: 'tax',
      label: 'Thuế',
      component: (
        <TaxTab
          formMode={dialog.formMode}
          state={dialog.formState}
          rows={dialog.tax.rows}
          selectedRowUuid={dialog.tax.selectedRowUuid}
          onRowClick={dialog.tax.handleRowClick}
          onAddRow={dialog.tax.handleAddRow}
          onDeleteRow={dialog.tax.handleDeleteRow}
          onCopyRow={dialog.tax.handleCopyRow}
          onPasteRow={dialog.tax.handlePasteRow}
          onMoveRow={dialog.tax.handleMoveRow}
          onCellValueChange={dialog.tax.cellValueChange}
          onCellCommit={dialog.tax.cellCommit}
          onHandleDetail={dialog.tax.importFromDetail}
        />
      )
    }
  ];

  if (dialog.formState.state.ma_gd_code === 'HD6TS') {
    tabs.push({
      id: 'TSCC',
      label: 'Tài sản/Công cụ',
      component: (
        <TSCCTab
          formMode={dialog.formMode}
          state={dialog.formState.state}
          rows={dialog.tscc.rows}
          selectedRowUuid={dialog.tscc.selectedRowUuid}
          selectedCell={dialog.tscc.selectedCell}
          onRowClick={dialog.tscc.handleRowClick}
          onCellClick={dialog.tscc.handleCellClick}
          onAddRow={dialog.tscc.handleAddRow}
          onDeleteRow={dialog.tscc.handleDeleteRow}
          onCopyRow={dialog.tscc.handleCopyRow}
          onPasteRow={dialog.tscc.handlePasteRow}
          onMoveRow={dialog.tscc.handleMoveRow}
          handleUpdateNonWritableFields={dialog.tscc.setNonWritableFields}
          handleUpdatePasteConfigs={dialog.tscc.setPasteConfigs}
          onCellValueChange={dialog.tscc.handleCellValueChange}
          isPasting={dialog.tscc.isPasting}
        />
      )
    });
  }

  return tabs;
};
